import { NgModule } from '@angular/core';
import { DeeplinkService } from './services/deeplink.service';
import { DEEP_LINK_STATES } from './deeplink.state';
import { UIRouterModule } from '@uirouter/angular';

@NgModule({
    imports: [
        UIRouterModule.forChild({ states: DEEP_LINK_STATES }),
    ],
    providers: [
        DeeplinkService,
    ],
})
export class DeeplinkModule {}
